export enum ScheduleConditionType {
	Time = 1,
	Distance = 2,
	EngineHours = 3
}
